<app-linkable
    typename="third parties"
    [displayValueProp]="displayValueProp"
    [linked]="linked"
    [unlinked]="unlinked"
    [orderByValueProperty]="true"
    [disabled]="disabled"
    (onOpenClicked)="openItem($event)"
    [hideActions]="hideActions"
    [hideFilter]="hideFilter"
    [allowAddNew]="allowAddNew"
    [rendererConfig]="rendererConfig"
    [allowEditItem]="allowEditItem"
    [allowBatchEdit]="allowBatchEdit"
    [allowOpenItem]="true"
>
</app-linkable>
